import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import InfoSvg from '@src/svgs/fr-info-icon.svg';
import { Container } from '@src/components/Container';
import { ContainerType } from '../Container/enums/containerType.enum';
import './styles.scss';

export const InfoNotice = ({ children }) => {
  return (
    <Container className="info-notice" type={ContainerType.INFO_SECONDARY}>
      <Svg className="info-notice__icon" src={InfoSvg} />
      <div className="info-notice__content">{children}</div>
    </Container>
  );
};

InfoNotice.propTypes = {
  children: PropTypes.any.isRequired,
};
